'use strict';

var util = require('../../../util/property-util');

module.exports = (function () {
    var dts;

    return {
        createInstance: function(deviceTypes) {
            dts = {};
            deviceTypes.forEach(function(deviceType) {
                dts[deviceType.type] = deviceType;
            })
        },

        getSize: function (type, sizeScale = 1) {
            if (util.isDefined(dts)) {
                const deviceType = dts[type];

                if (util.isDefined(deviceType)) {
                    const size = deviceType.size;

                    if (util.isDefined(size)) {
                        return {
                            width : size.width * sizeScale,
                            height: size.height * sizeScale,
                            sizeScale: sizeScale
                        }
                    }
                }
            }

            return undefined;
        },

        getDeviceType: function (type) {
            if (util.isDefined(dts)) {
                let ports;
                const deviceType = dts[type];
                return deviceType;
            }

            return undefined;
        }
    };
})();